import script from "./Leaderboard.vue?vue&type=script&setup=true&lang=ts"
export * from "./Leaderboard.vue?vue&type=script&setup=true&lang=ts"

import "./Leaderboard.vue?vue&type=style&index=0&id=86c76372&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-86c76372"]])

export default __exports__